import React, { FC, ComponentProps } from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { LazyComponent } from '@fiverr-private/ui_utils';
import { raiseToast } from '@fiverr-private/toast';
import { PACKAGE_T_KEY } from '../../constants';
import { logError } from '../utils';
import { BookConsultationDrawerProps } from './BookConsultationDrawer';

const lazyImport = () =>
  import(
    /* webpackChunkName: 'BookConsultationDrawer' */ './BookConsultationDrawer'
  );

export const LazyBookConsultationDrawer: FC<
  Omit<
    ComponentProps<typeof LazyComponent<BookConsultationDrawerProps>>,
    'lazyImport'
  >
> = ({ onError, ...rest }) => {
  const onErrorInner = (error) => {
    if (typeof onError === 'function') {
      onError(error);
    }

    logError({
      error,
      description: 'Failed to lazy load BookConsultationDrawer',
    });

    raiseToast({
      message: translate(`${PACKAGE_T_KEY}.loading_error`),
      type: 'error',
    });
  };

  return (
    <LazyComponent lazyImport={lazyImport} onError={onErrorInner} {...rest} />
  );
};
